import { EmptyView } from '@components'

import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { SpotItemProduct } from '../../../../assets/images'

interface SharedDocumentsEmptyStateProps {
  isBoWithCpa?: boolean
}

export const SharedDocumentsEmptyState = ({ isBoWithCpa = false }: SharedDocumentsEmptyStateProps): ReactElement => {
  const { t } = useTranslation()

  const tTitle = isBoWithCpa ? t('documents.shared_by_me.empty_state.title') : t('documents.unsorted.empty_state.title')
  const tDescription = isBoWithCpa
    ? t('documents.shared_by_me.empty_state.description')
    : t('documents.folder_view.empty_state.description')

  return <EmptyView illustration={<SpotItemProduct />} tTitle={tTitle} tDescription={tDescription} />
}
